import { ISubstateAction } from './state-actions';
import { UI_STATE_ACTIONS } from './ui-state.actions';
import { DEFAULT_UI_STATE, IUIState } from './ui-state.models';

export const uiReducer = (state: IUIState = DEFAULT_UI_STATE, action: ISubstateAction<UI_STATE_ACTIONS>): IUIState => {
	switch (action.type) { }

	return state;
};
